import React from 'react';
import DateRangePicker from '../common/DateRangePicker/DateRangePicker';
import AsyncSearchSelect from '../common/AsyncSearchSelect';
import { selectStyles } from '../../utils';
import { MdSearch, MdRefresh } from "react-icons/md";

/** Server-side filters for User Records (get/app/users). */
export default function UsersFiltersBar({
    draftFilters,
    setDraftFilters,
    onSearch,
    onReset,
    fetchTagKeyOptions,
    tagKeySelectEnabled = true,
}) {
    return (
        <div className="list-page-filter-bar">
            <div className="list-page-filter-fields row g-3">
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Notify Sphere ID"
                        aria-label="Notify Sphere ID"
                        value={draftFilters.notify_sphere_id}
                        onChange={(e) => setDraftFilters((d) => ({ ...d, notify_sphere_id: e.target.value }))}
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        aria-label="Email"
                        value={draftFilters.email}
                        onChange={(e) => setDraftFilters((d) => ({ ...d, email: e.target.value }))}
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Phone"
                        aria-label="Phone"
                        value={draftFilters.phone}
                        onChange={(e) => setDraftFilters((d) => ({ ...d, phone: e.target.value }))}
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        aria-label="Name"
                        value={draftFilters.name}
                        onChange={(e) => setDraftFilters((d) => ({ ...d, name: e.target.value }))}
                    />
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <div className="input-group list-page-tag-filter-group">
                        <div className="list-page-tag-filter-key">
                            <AsyncSearchSelect
                                classNamePrefix="ns-select"
                                isClearable
                                placeholder="Tag key"
                                enabled={tagKeySelectEnabled}
                                fetchOptions={fetchTagKeyOptions}
                                value={draftFilters.tag_key || null}
                                onChange={(opt) => setDraftFilters((d) => ({ ...d, tag_key: opt?.value ?? '' }))}
                                styles={selectStyles}
                            />
                        </div>
                        <input
                            type="text"
                            className="form-control list-page-tag-filter-value"
                            placeholder="Tag value"
                            aria-label="Tag value"
                            value={draftFilters.tag_value}
                            onChange={(e) => setDraftFilters((d) => ({ ...d, tag_value: e.target.value }))}
                        />
                    </div>
                </div>
                <div className="list-page-filter-field col-12 col-lg-4">
                    <DateRangePicker
                        dateFrom={draftFilters.dateFrom || ''}
                        dateTo={draftFilters.dateTo || ''}
                        preset={draftFilters.datePreset || ''}
                        onChange={({ dateFrom, dateTo, preset }) =>
                            setDraftFilters((d) => ({
                                ...d,
                                dateFrom: dateFrom || '',
                                dateTo: dateTo || '',
                                datePreset: preset || '',
                            }))
                        }
                        label=""
                        placeholder="Created date"
                        allowClear
                    />
                </div>
                <div className="list-page-filter-field list-page-filter-actions col-12 col-lg-4">
                    <div
                        className="add_app"
                        style={{
                            display: 'flex',
                            gap: '8px',
                            flexWrap: 'nowrap',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <button type="button" className="add_app_btn btn_theme_primary" title="Apply filters" onClick={onSearch}>
                            <MdSearch />
                            <span>Search</span>
                        </button>
                        <button type="button" className="add_app_btn_secondary btn_theme_secondary" title="Reset filters" onClick={onReset}>
                            <MdRefresh />
                            <span>Reset</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
